import React, { useEffect, useState } from "react";

export default function Statistics() {
  const [predicciones, setPredicciones] = useState([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    const hoy = new Date().toISOString().split("T")[0];
    const archivo = `/${hoy}_top10.json`;

    fetch(archivo)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Archivo no encontrado");
        }
        return res.json();
      })
      .then((data) => setPredicciones(data))
      .catch((err) => {
        console.error("❌ Error al cargar predicciones:", err.message);
        setError(true);
      });
  }, []);

  return (
    <div className="min-h-screen bg-gray-950 text-white p-6">
      <h1 className="text-2xl font-bold mb-4">📊 Estadísticas del Día</h1>
      <p className="text-gray-400 mb-6">Estas son las 10 mejores predicciones generadas por la IA.</p>

      {error ? (
        <div className="bg-red-800 p-4 rounded-xl shadow text-center text-white">
          ❌ No se pudo cargar el archivo de predicciones del día.
        </div>
      ) : predicciones.length === 0 ? (
        <div className="bg-gray-800 p-4 rounded-xl shadow text-center text-blue-400">
          📈 Cargando predicciones...
        </div>
      ) : (
        <table className="w-full text-left mt-4">
          <thead>
            <tr className="text-sm text-gray-300 border-b border-gray-600">
              <th>#</th>
              <th>Liga</th>
              <th>Equipos</th>
              <th>Predicción 1</th>
              <th>Predicción 2</th>
              <th>Confianza</th>
            </tr>
          </thead>
          <tbody>
            {predicciones.map((ap, i) => (
              <tr key={i} className="border-b border-gray-700">
                <td>{i + 1}</td>
                <td>{ap.liga}</td>
                <td>{ap.away} vs {ap.home}</td>
                <td>{ap.prediccion_1}</td>
                <td>{ap.prediccion_2}</td>
                <td>{(ap.confianza * 100).toFixed(1)}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
